module.exports = __webpack_public_path__ + "media/images/athletes/2935-ed5f6bd4b0e240ee18f6d7ae0fd12cb6.png";